<template>
  <div class="fluid self_reported_courses w-100">
    <div class="courses_section" v-if="isCoursesLoaded">
      <template v-if="(programCourses.length > 0 && !$parent.isGuestLogin)">
        <div class="list_container">
          <template v-for="(pg, i) in programCourses">
<!--1-->    <div>

            <div class="accordion_crd">
                <b-card-header header-tag="header" class="row sec_hd" role="tab"  block v-b-toggle="'req_1'" variant="info" v-if="pg.courseRequirement">
                  <div class="col-1 ic_container">
                    <div class="ic ic-expand_r"></div>
                    <div class="ic ic-collapse_r"></div>
                  </div>
                  <div class="col-10 hd_txt">
                    <div>{{pg.title}}</div>
                  </div>
                </b-card-header>

                <b-collapse id="req_1" visible role="tabpanel" v-if="pg.courseRequirement" >
                  <b-card-body class="accordion_crd_content">

                    <div class="row sec_content">
                      <div class="col-12 sec_txt">
                        <div>{{pg.courseRequirement}}</div>
                      </div>
                    </div>

                  </b-card-body>
                </b-collapse>
              </div>

              <div class="row sec_content">
                <div class="col-12 sub_sec_txt">
                  <div class="entity_node_tree">
                    <tree-node v-for="category in pg.children" :key="category.title" :category="category" :tabIndex="1"> </tree-node>
                  </div>
                </div>
              </div>

<!--1-->    </div>
          </template>
        </div>
      </template>
    </div>

  </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import _ from 'lodash'
  import TreeNode from './TreeNode'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'program-courses',
    props: ['pathwayId'],
    components: {
      TreeNode
    },
    data () {
      return {
        programCourses: [],
        userId: localStore.getItem('userid'),
        username: localStore.getItem('userFullName'),
        isCoursesLoaded: false,
        clickedCourse: '',
        selectedStatus: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        }
      }
    },
    mounted () {
      this.showLoader()
      this.loadCourseList()
    },
    methods: {
      ...mapActions([
        'loadProgramCourseList',
        'updateProgramCourseStatus',
        'navigateUserToCourseDashboard'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      async loadCourseList () {
        this.loadProgramCourseList(this.pathwayId).then(result => {
          this.programCourses = result
          this.totalElements = result.length
          this.hideLoader()
          this.selected = [],
          this.isCoursesLoaded = true
        })
      },
      resetPage () {
        this.loadCourseList()
      },
    }
  }
</script>

<style>
  .title-txt {
    color: #fff;
    margin-top: 3px;
    font-weight: 500;
    text-align: center;
  }

  div[id^="courseStatusPopup-"] .popover {
    transform: translate3d(-8px, 20px, 0px) !important;
    max-width: 220px !important;
    width: 220px !important;
    height: 225px !important;
    margin-top: 15px;
  }

  div[id^="courseStatusPopup-"] .popover .arrow {
    display: none !important;
  }

  .form-check-input {
    top: 12px;
    cursor: pointer;
  }

  .status-not-started {
    background: #b4b4b4 !important;
  }

  .status-in-progress {
    background: #dd9623 !important;
  }

  .status-completed {
    background: #0a7714 !important;
  }

  .status-not-completed {
    background: #f40909 !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/transfer/components/ProgramCourses.vue